export default [
  {
    path: 'g-fin/pre-caixa',
    name: 'pre-caixa',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Prê-caixa',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Financeiro', link: 'financeiro' },
        { name: 'Prê-caixa' }
      ]
    }
  },
]